import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import homepageLaneQuery from "./fragments/homepageLaneQuery"

/**
 * @description: This is intended to be used in internal admin, default query returns no deals
 * @author: Richard Scoones
 */
export const query = gql`
  query PerksHomepages($id: ID!) {
    perksHomepageById(id: $id) {
      uuid
      name
      description
      bannerTagId
      birthdayTagId
      topCategoriesId
      lanes {
        linkedEntityUrl
        type
        headerText
        bodyText
        image
        query {
          ...homepageLaneQuery
        }
        fallbackQuery {
          ...homepageLaneQuery
        }
      }
      state
    }
  }
  ${homepageLaneQuery}
`

export const perksHomepageNoDealsKey = getQueryNames(query)[0]

export default query
